export default {
  phpFormatToJS: date => (date ? date.split(" ")[0] : undefined)
};




// WEBPACK FOOTER //
// ./src/utils/date.js